import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { Link } from 'gatsby'

import { MANAGED_ROUTE } from '../../routes'

import awsBox from './aws-box.svg'

const AwsSolutionsCard = () => {
  return (
    <Link to={MANAGED_ROUTE} className="AwsSolutionsCard">
      <Card>
        <CardBody>
          <div className="AwsSolutionsCard__icon">
            <img src={awsBox} alt="aws box" />
          </div>

          <div className="AwsSolutionsCard__details">
            <h4 className="AwsSolutionsCard__title">Managed Solutions</h4>
            <div className="AwsSolutionsCard__desc">
              A comprehensive and continuous approach to supporting your cloud infrastructure
            </div>
          </div>
        </CardBody>
      </Card>
    </Link>
  )
}

export default AwsSolutionsCard
